import { useEnvStore } from 'store'
import { RequestService } from '../RequestService'

class InvestFinancialRequest extends RequestService {
  constructor() {
    super()
  }

  protected setBaseUrl(): string {
    const envStore = useEnvStore()
    return envStore.config?.app || ''
  }

  getRecommendProducts() {
    return this.post<InvestFinancialResponse.InvestFinancialProductItem[]>('/Fm/Publics/recommandProductList')
  }

  getProducts(data?: { productType: number | string }) {
    return this.post<InvestFinancialResponse.InvestFinancialProductItem[]>('/Fm/Publics/productList', data)
  }

  /**
   * 获取理财产品详情
   * @param id 产品ID
   * @returns 理财产品详情
   */
  getProductDetail(data: { productId: InvestFinancialResponse.ProductId }) {
    return this.post<InvestFinancialResponse.InvestFinancialProductDetail>(`/Fm/Publics/getProductInfo`, data)
  }

  /** 预约募集项目 */
  feFinanceApplyToBuy(data: { productId: InvestFinancialResponse.ProductId }) {
    return this.post(`/Fm/Users/reserveRaise`, data)
  }

  /** 申购 */
  buyFinance(data: { subProductId: InvestFinancialResponse.ProductId; amount: string; uvId: string }) {
    return this.post(`/Fm/Users/subscription`, data)
  }

  /** 自动申购 */
  feAutoSubscription(data: { subProductId: InvestFinancialResponse.ProductId; autoBuy: number }) {
    return this.post<{ status: number }>(`/Fm/Users/autoSubscription`, data)
  }

  /** 获取自动申购产品列表 */
  getAutoSubscriptionProducts(data = {}) {
    return this.post<InvestFinancialResponse.AutoSubscriptionProductItem[]>(`/Fm/Users/userAutoSubscriptionList`, data)
  }

  /** 获取理财资产 */
  getFinancialAsset() {
    return this.post<InvestFinancialResponse.FinancialAsset>(`/Fm/Users/assetsFinancial`)
  }

  /** 获取申购历史 */
  getSubscriptionHistory(data: { page: number; pageSize: number }) {
    return this.post<HasPageInfoResponse<InvestFinancialResponse.SubscriptionHistory>>(`/Fm/Trace/subscription`, data)
  }

  /** 获取赎回历史 */
  getRedeemHistory(data: { page: number; pageSize: number }) {
    return this.post<HasPageInfoResponse<InvestFinancialResponse.RedeemHistory>>(`/Fm/Trace/redemption`, data)
  }

  /** 获取利息历史 */
  getInterestHistory(data: { page: number; pageSize: number }) {
    return this.post<HasPageInfoResponse<InvestFinancialResponse.InterestHistory>>(`/Fm/Trace/earningsRelease`, data)
  }

  /** 获取奖励历史 */
  getRewardHistory(data: { page: number; pageSize: number }) {
    return this.post<HasPageInfoResponse<InvestFinancialResponse.RewardHistory>>(`/Fm/Trace/rewardList`, data)
  }

  /** 获取仓位详情 */
  getPositionDetail(data: { positionId: number }) {
    return this.post<InvestFinancialResponse.PositionDetail>(`/Fm/Trace/positionInfo`, data)
  }
  /** 理财赎回产品
   * @param data.positionId 仓位ID
   * @param data.amount 赎回金额，活期参数

   */
  feFinanceRedemption(data: { positionId: number; amount?: string }) {
    return this.post<{ status: number }>(`/Fm/Users/redemption`, data)
  }
}

export const InvestFinancialService = new InvestFinancialRequest()
